import { gql } from '@apollo/client';

export const SET_DEFAULT_TOKENIZED_PAYMENT_OPTION = gql`
  mutation setDefaultTokenizedPaymentOption(
    $input: SetDefaultTokenizedPaymentOptionInput!
  ) {
    setDefaultTokenizedPaymentOption(input: $input)
  }
`;
